import { apiClient } from '@/lib/api'

const SETTINGS_BASE = '/v1/settings'

/**
 * Settings API (Superadmin only)
 * All endpoints work with singleton records (id=1)
 */

// National Currency
export const getNationalCurrency = async () => {
  const response = await apiClient.get(`${SETTINGS_BASE}/national-currency/`)
  return response.data
}

export const updateNationalCurrency = async (data) => {
  const response = await apiClient.patch(`${SETTINGS_BASE}/national-currency/`, data)
  return response.data
}

// Franchise City
export const getFranchiseCity = async () => {
  const response = await apiClient.get(`${SETTINGS_BASE}/franchise-city/`)
  return response.data
}

export const updateFranchiseCity = async (data) => {
  const response = await apiClient.patch(`${SETTINGS_BASE}/franchise-city/`, data)
  return response.data
}

// Franchise
export const getFranchise = async () => {
  const response = await apiClient.get(`${SETTINGS_BASE}/franchise/`)
  return response.data
}

export const updateFranchise = async (data) => {
  const response = await apiClient.patch(`${SETTINGS_BASE}/franchise/`, data)
  return response.data
}

// Subscribe (signature)
export const getSubscribe = async () => {
  const response = await apiClient.get(`${SETTINGS_BASE}/subscribe/`)
  return response.data
}

export const updateSubscribe = async (data) => {
  const response = await apiClient.patch(`${SETTINGS_BASE}/subscribe/`, data)
  return response.data
}

// Fetch all settings at once
export const getAllGlobalSettings = async () => {
  const [currency, city, franchise, subscribe] = await Promise.all([
    getNationalCurrency(),
    getFranchiseCity(),
    getFranchise(),
    getSubscribe(),
  ])

  return {
    currency,
    city,
    franchise,
    subscribe,
  }
}
